import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ComunicadoService {

  constructor(
    private http: HttpClient
  ) { }

  getComunicado(localExibicao: any, tipoPortal: any): Promise<any> {
    return this.http.get(environment.apiAdmin + '/mod-admin?localExibicaoMensagemComunicado=' + localExibicao + '&tipoPortal=' + tipoPortal)
    .toPromise().then(
      res => res

    )}

}
